export enum ActivitySuccessResultServiceChangeFlowOrder {

    /** Результат работ */
    completeActivityResultStep = 1,

    /** Установленное основное оборудование */
    installGeneralDeviceStep = 2,

    /** Добавление 'Установленное основное оборудование' */
    installGeneralDeviceAddedMoreStep = 3,

    /** Установленная сим-карта */
    installSimcardStep = 4,

    /** Добавление 'Установленная сим-карта' */
    installSimcardAddedMoreStep = 5,

    /** Демонтированное основное оборудование */
    uninstallGeneralDeviceStep = 6,

    /** Добавление 'Демонтированное основное оборудование' */
    uninstallGeneralDeviceAddedMoreStep = 7,

    /** Демонтированная сим-карта */
    uninstallSimcardStep = 8,

    /** Добавление 'Демонтированная сим-карта' */
    uninstallSimcardAddedMoreStep = 9,
    
    /** Фото документов */
    requiredAttachmentsStep = 10,

    /** Резюме */
    completeActivitySummaryStep = 11,

    /** Подпись */
    completeActivitySignatureStep = 12,

    /** Сохранение результатов */
    saveResults = 13
}